import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp, useConfiguration } from '@travel-frontend/core';
import { IconArrowForward } from '@travel-frontend/icons';
import { Trans } from 'next-i18next';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '../../components/PartnerRecommendation/components/Container.js';
import { Button, HeadlineLarge, LabelSmallBold, NoWrap, ParagraphMedium, Stack } from '../../primitives/index.js';
export const PartnerRecommendation = memo(function PartnerRecommendation({
  onClick,
  links,
  variant = 'info'
}) {
  const {
    t
  } = useTranslation('partnerRecommendation');
  const mdUp = useBreakpointUp('md');
  const brandName = useConfiguration('brandName');
  const handleOnClick = linkKey => {
    onClick?.(linkKey);
  };
  return _jsxs(Container, {
    spacing: 0.75,
    children: [_jsx(HeadlineLarge, {
      children: t('title')
    }), _jsx(ParagraphMedium, {
      children: t('description')
    }), _jsx(ParagraphMedium, {
      children: _jsx(Trans, {
        i18nKey: "partnerRecommendation:description2",
        components: {
          b: _jsx(NoWrap, {
            as: "b"
          })
        },
        values: {
          brandName
        }
      })
    }), _jsx(Stack, {
      direction: "row",
      children: links?.map(({
        labelKey,
        url
      }, index) => _jsx(Button, {
        as: "a",
        variant: variant,
        href: url,
        target: "_blank",
        onClick: () => {
          handleOnClick(labelKey);
        },
        iconPosition: "right",
        justifyContent: "space-between",
        icon: _jsx(IconArrowForward, {}),
        children: _jsx(LabelSmallBold, {
          color: "contentInversePrimary",
          children: t(`${labelKey}Button`, {
            context: mdUp ? '' : 'short'
          })
        })
      }, `${url}_${index}`))
    })]
  });
});